import React from 'react';
import '../css/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
         
          <div className="footer-left">
            {/* <h2 className="footer-title">Luxury Fragrance Decants</h2>
            <div className="footer-tags">
              <span className="footer-tag">Authentic</span>
              <span className="footer-separator">•</span>
              <span className="footer-tag">Trusted</span>
              <span className="footer-separator">•</span>
              <span className="footer-tag">Quick</span>
            </div> */}
          </div>

          {/* Right Side - Social Icons */}
          <div className="footer-right">
            <div className="social-icons">
              <a href="#" className="social-icon" aria-label="Instagram">
                <svg className="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1012.324 0 6.162 6.162 0 10-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 101.437 1.44 1.44 1.44 0 00-1.437-1.44z"/>
                </svg>
              </a>
              {/* <a href="https://www.facebook.com/Subhojit27?mibextid=wwXIfr&rdid=X2mciswn8XZXhdlX&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16veLMWKFj%2F%3Fmibextid%3DwwXIfr#" className="social-icon" aria-label="Facebook">
                <svg className="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a> */}
              <a href="#" className="social-icon" aria-label="WhatsApp">
                <svg className="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.032 0c-6.626 0-12 5.374-12 12 0 2.175.585 4.216 1.605 5.968L0 24l6.133-1.609c1.724 1.006 3.718 1.609 5.899 1.609 6.627 0 12-5.374 12-12 0-6.627-5.373-12-12-12zm5.774 16.914c-.313.877-1.548 1.604-2.487 1.683-.401.033-.924.075-2.686-.286-1.48-.303-3.319-1.079-4.63-2.373-1.982-1.982-3.254-4.57-3.335-7.174-.034-1.1.283-2.063.878-2.807.416-.521 1.051-.814 1.693-.814h.145c.186 0 .368.01.516.044.253.052.463.26.537.511.153.524.454 1.827.494 1.958.041.13.069.289.021.452-.048.162-.074.283-.149.434-.075.151-.151.302-.222.437-.075.156-.154.323-.111.52.043.198.216.938.466 1.623.36.996.841 1.874 1.449 2.646.531.679 1.178 1.244 1.91 1.684.492.295 1.035.514 1.604.652.438.105.835.153 1.213.153.122 0 .24-.007.356-.019.464-.048.85-.333 1.058-.75l.462-.942c.173-.346.423-.594.754-.689.261-.075.548-.058.793.112.245.169.442.393.562.654.171.368.372.948.429 1.389.057.441-.02.877-.225 1.269z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom - Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">© 2026 Scentures. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;